export default __webpack_public_path__ + "static/media/Photo.0cd91e76.jpeg";